import { Themes } from '@sbercloud/uikit-product-utils';
import { useEffect, useState } from 'react';
import { tinykeys } from 'tinykeys';

import {
  CLASSNAME_BY_THEME,
  getInitialTheme,
  getTheme,
  updateTheme,
} from '../utils/theme';

export function useBootstrapTheme() {
  const [theme, setTheme] = useState<Themes.Green | Themes.GreenDark>(
    () => getInitialTheme().theme,
  );

  useEffect(() => {
    const unsub = tinykeys(window, {
      ['Alt+Shift+KeyT'](event) {
        event.preventDefault();
        const newTheme = getTheme(theme);

        setTheme(newTheme);
        updateTheme(newTheme);
      },
    });

    return () => {
      unsub();
    };
  }, [theme]);

  return {
    theme,
    themeClassName: CLASSNAME_BY_THEME[theme],
  };
}
